import React from 'react';
import './style.css';
import ImageHero from '../../img/design/hero.webp';

const ColorPalette = () => {
  const colors = [
    { hex: '#EAF8E7' },
    { hex: '#C1E6BA' },
    { hex: '#4EA771' },
    { hex: '#013237' },
  ];

  return (
    <div className="color-palette-container">
      <div className="font-info">
        <span className="font-label">Font</span>
        <h2 className="font-name">Segoe UI</h2>
      </div>
      <div className="palette-wrapper">
        <div className="palette-swatches">
          {colors.map((color, index) => (
            <div key={index} className="color-swatch">
              <div
                className="color-box"
                style={{ backgroundColor: color.hex }}
              ></div>
              <span className="color-hex">{color.hex}</span>
            </div>
          ))}
        </div>
        <div className="palette-image">
          <img src={ImageHero} alt="exmp" />
        </div>
      </div>
    </div>
  );
};

export default ColorPalette;
